__turbopack_context__.v({
  "address": "gUtPzW_address",
  "addressName": "gUtPzW_addressName",
  "addressNameWrapper": "gUtPzW_addressNameWrapper",
  "addressWrapper": "gUtPzW_addressWrapper",
  "buttonWrapper": "gUtPzW_buttonWrapper",
  "defaultInfoTagWeb": "gUtPzW_defaultInfoTagWeb",
  "editButton": "gUtPzW_editButton",
  "entryWrapper": "gUtPzW_entryWrapper",
  "icon": "gUtPzW_icon",
  "invoiceTypeLabel": "gUtPzW_invoiceTypeLabel",
  "removeButton": "gUtPzW_removeButton",
  "savedAddress": "gUtPzW_savedAddress",
});
